module.exports = __webpack_public_path__ + "src/images/products/prep/37_Classic Seersucker Short Sleeved Shirt.png";